import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext'; // Assuming you have useAuth hook

const ProtectedRoute = ({ children }) => {
  const { user } = useAuth(); // Access user from AuthContext

  // Redirect to login if the user is not authenticated
  if (!user) {
    return <Navigate to="/login" />;
  }

  return children;  // Return protected component if user is authenticated
};

export default ProtectedRoute;
